export default "__VITE_ASSET__8sveSBMJ__"